export class AttendanceMonthRequest {
    year?:number;
    month?: number;
    departmentId?: number;
    unitId?: number;
    shift?: string;
    category?:string


    /**
     * @param year
     * @param month 
     * @param departmentId 
     * @param unitId 
     * @param shift 
     * @param category
     */
    constructor(year?:number,month?: number, departmentId?: number, unitId?: number, shift?: string, category?:string) {
        this.year=year
        this.month = month;
        this.departmentId = departmentId;
        this.unitId = unitId;
        this.shift = shift;
        this.category = category
    }
}